import React, { useEffect, useState, createRef } from "react"
import _ from "lodash"
import { toast } from 'react-toastify';
import Modal from "react-responsive-modal"

import OnboardingPageInterests from '../Onboarding/components/OnboardingPageInterests';

import {
  toastErrorAndWarningOptions,
  toastDefaultOptions
} from '../../utils/functions';

export default function Especialidades({ interests, refetchOnboarding }) {
  const [selectedList, setSelectedList] = useState(null)
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const currentPageRef = createRef();
  const [interestData, setInterestData] = useState(null)

  useEffect(() =>{
    if(interests) {
      setInterestData(interests)
      const items = _.get(interests, 'qx_userinterests', [])
      const formattedItem = items.filter(item => item.nu_size).map(item => ({
        grau: item.nu_size,
        id: item.rk_typesuggestion,
        name: item.wx_namesuggestion
      }))
      setSelectedList(formattedItem)
    }
  }, [interests])

  function openModal(){
    setModalIsOpen(true)
  }

  function closeModal() {
    setModalIsOpen(false)
  }

  async function advancePage(currentPageIndex) {
    setLoading(true)
    if (currentPageIndex === -1) {
      return;
    }
    if (currentPageRef.current) {
      try {
        await currentPageRef.current.saveForm();
        toast.success(
          'Informações atualizadas com sucesso',
          toastDefaultOptions
        );
        setModalIsOpen(false);
        refetchOnboarding();
      } catch (e) {
        if (e.response && e.response.data) {
          const errorMessage = e.response.data.error;
          if (typeof currentPageRef.current.showErrors === 'function') {
            currentPageRef.current.showErrors(e.response.data.error);
          }
          toast.warn(errorMessage, toastErrorAndWarningOptions);
        }
      } finally {
        setLoading(false);
      }
    }
  }

  async function savePageInterest() {
    try {
      await advancePage(interestData.index);
    } catch (e) {
      if (e.response && e.response.data) {
        const errorMessage = e.response.data.error;

        toast.warn(errorMessage, toastErrorAndWarningOptions);
      }
    }
  }

  return(
    <div className="cursos bg-white-perfil" id="especialidades">
      <div className="container-fluid">
        <div className="row justify-content-between">
          <div className="col-6">
            <h5
              className="d-inline-block"
              data-tip="As suas áreas de interesse são usadas para personalizar as recomendações de cursos e trilhas. Você pode editar este campo sempre que quiser"
            >
              Áreas de interesse
            </h5>
          </div>
          <button type="button" className="btn btn-icon" onClick={openModal}>
            <i className="fa fa-pencil" aria-hidden="true" />
          </button>
        </div>
        <div className="row">
          <div className="col">
            {selectedList && selectedList.length === 0 && <p>Nenhuma área de interesse selecionada</p>}
            {selectedList && selectedList.length > 0 && (
              <div data-toggle="buttons">
                {selectedList.map(suggestion => {
                  return (
                    <label className="btn btn-grey interesses-space" key={suggestion.id}>
                      <input type="checkbox" />
                      <i
                        className="fa fa-star-o blue-tooltip"
                        aria-hidden="true"
                        data-placement="bottom"
                        data-tip="151 XP"
                      />{" "}
                      {suggestion.name}
                    </label>
                  )
                })}
              </div>
            )}  
          </div>
        </div>
      </div>

      {/* Modal para edicao de especialidades */}
      <Modal
        open={modalIsOpen}
        onClose={closeModal}
        classNames={{ modal: "lit-modal-especialidade" }}
      >
        <div className="modal-content" id="modalGroup">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Editar áreas de interesse
            </h5>
          </div>
          <div className="modal-body">
            {interestData && (
              <OnboardingPageInterests
                index={interestData.index}
                data={interestData}
                isVisibleTitle={false}
                ref={currentPageRef}
              />
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-modal__cancel"
              disabled={loading}
              onClick={closeModal}
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={savePageInterest}
              disabled={loading}
              className={`btn btn-modal__approve ${loading && " btn-loading"}`}
            >
              Salvar
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}


